import React, { useMemo } from 'react';
import TimeIcon from '@tradera/blueprint/theme/icons2/time.svg?jsx';
import PropTypes from 'prop-types';

import { STORAGE_KEYS } from 'tradera-constants/storage';
import StorageService from 'static/script/app/data/storage-service';
import { useIsFeatureEnabled } from 'tradera-hooks/use-is-feature-enabled';
import useRecentSearchesUpdated from 'tradera-hooks/use-recent-searches-updated';
import Tags from '../tags/tags';
import { addRecentSearch } from 'components/search/helpers/suggestions-api';
import { toSearchString } from 'tradera-utils/url';
import './recent-searches-tags.scss';

const RecentSearchesTags = ({ inHeader, className }) => {
    const recentSearchesUpdated = useRecentSearchesUpdated();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const tags = useMemo(() => getPreviousSearches(inHeader ? 7 : 16), [
        inHeader,
        recentSearchesUpdated
    ]);

    const isEnabled = useIsFeatureEnabled('recent-searches-tags');

    if (!isEnabled || !tags || tags.length === 0) {
        return null;
    }

    return (
        <div
            className={`recent-searches-tags ${
                inHeader ? 'in-header' : ''
            } ${className}`}>
            <TimeIcon
                className={`icon icon-md ${
                    inHeader ? 'icon-white ml-1 mr-0 mr-md-0 mb-1' : 'ml-2 mr-1'
                }`}
                alt="Recent searches"
            />
            <Tags
                gaCategory="Recent Searches"
                gaAction="Navigation"
                onClickTag={tag => addRecentSearch(tag.name)}
                scroll={!inHeader}
                tags={tags}
                titleOnSameLine
            />
        </div>
    );
};

const getPreviousSearches = limit => {
    const previousSearchService = new StorageService(
        STORAGE_KEYS.SEARCH_RECENT
    );
    const previousResults =
        previousSearchService.fetch().orderByTimestamp() || [];
    return previousResults.splice(0, limit).map(item => ({
        name: item.key,
        url: `/search${toSearchString({ q: item.key })}`
    }));
};

RecentSearchesTags.defaultProps = {
    className: ''
};

RecentSearchesTags.propTypes = {
    className: PropTypes.string,
    inHeader: PropTypes.bool.isRequired
};

export default RecentSearchesTags;
